import { ComponentProps } from 'preact/compat';

import { cn } from '@/lib/utils';

import { SpeakerIcon } from '../icons';
import { AnimalAlertType } from './constants';

interface AnimalAlertButtonProps extends ComponentProps<'button'> {
  alertType: AnimalAlertType;
  selected?: boolean;
}

const AnimalAlertButton = ({
  alertType,
  selected = false,
  disabled = false,
  onClick,
  className,
  children,
}: AnimalAlertButtonProps) => {
  return (
    <button
      type="button"
      aria-pressed={selected}
      disabled={disabled}
      className={cn(
        'preflight preflight-button group shrink-0 rounded-full bg-[linear-gradient(to_right,#CDD565,#FFCE1F,#F18C43,#F9A5E7)] p-0.5 text-sm font-semibold text-forest-core transition-opacity disabled:cursor-not-allowed',
        className,
      )}
      onClick={onClick}
    >
      <div className="flex items-center justify-center rounded-full bg-sun-200 px-2 group-aria-pressed:bg-transparent">
        <SpeakerIcon className="mr-1 size-4 transition-transform group-aria-pressed:rotate-[-21.07deg]" />
        <span className="preflight tagText">{alertType}</span>
        {children}
      </div>
    </button>
  );
};

export default AnimalAlertButton;
